import { loadStripe } from '@stripe/stripe-js'
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'
import donateCommonMixin from '@/mixins/donations/donateCommonMixin.js'
import fundraiserPagePublicFetchMixin from '@/mixins/fundraiserPagePublicFetchMixin.js'
import { useFundraiserPublicStore } from '@/stores/fundraiserPublic.js'
import fetchDataMixin from '@/mixins/fetchDataMixin.js'

export default {
  mixins: [ donateCommonMixin, fundraiserPagePublicFetchMixin, fetchDataMixin],
  computed: {
    returnPageRoute() {
      return { name: 'FundraiserPageDonationReturnPublicPage', params: { fundraiserPageId: this.fundraiserPage.id, donationId: this.Donation.id } }
    }
  },
  async beforeMount() {
    await this.fetchData(useFundraiserPagePublicStore().fetchItemById, this.fundraiserPageId)
    await this.fetchData(useFundraiserPublicStore().fetchItemById, this.fundraiserPage.fundraiser_id)
    if(this.fundraiser && this.fundraiser.settings && this.fundraiser.settings.allow_donors_to_absorb_credit_card_fees) {
      this.DonationTakeCareOfFees = true
    }
  },
  async beforeUnmount() {
    await this.cancelDonation()
  },
  methods: {
    async fetchClientSecret() {
      try {
        this.ValidationErrorMessage = null
        this.Loading = true
        const response = await useFundraiserPagePublicStore().startDonation({
          name: this.DonationName,
          fundraiser_page_id: this.fundraiserPage.id,
          app_fee: this.DonationAppFeeAmount,
          amount: this.donationAmountToCharge,
          anonymous_name: this.DonationAnonymousName,
          anonymous_amount: this.DonationAnonymousAmount,
          comment: this.DonationComment,
          recurring: this.DonationRecurring,
          recurrences: this.DonationRecurrences
        })
        this.Donation = response.donation
        return response.payment_service.client_secret
      } catch (e) {
        console.error(e)
        this.Loading = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    },
    async startDonation() {
      if(this.StripeCheckoutObject) {
        await this.StripeCheckoutObject.destroy()
        this.DonationGatewayActive = false
      }
      const stripe = await loadStripe(import.meta.env.VITE_APP_STRIPE_PUBLISHABLE_KEY, {
        stripeAccount: this.fundraiserPage.cached.payment_service_account_id,
      })
      this.DonationGatewayActive = true
      this.StripeCheckoutObject = await stripe.initEmbeddedCheckout({
        fetchClientSecret: this.fetchClientSecret,
        onComplete: async (complete, completed) => {
          await this.StripeCheckoutObject.destroy()
          this.DonationGatewayActive = false
          this.DonationCompleted = true
          this.DonationAmount = null
          this.DonationTakeCareOfFees = false
          this.DonationAnonymousName = false
          this.DonationAnonymousAmount = false
          this.DonationShowCommentForm = false
          this.DonationComment = null
          this.StripeCheckoutObject = null
          this.$notify('Donation completed successfully!')
          if(this.Donation) {
            this.$router.push(this.returnPageRoute)
          }
        }
      });
      // Mount Checkout
      this.StripeCheckoutObject.mount('#checkout');
    },
    async cancelDonation() {
      await this.StripeCheckoutObject.destroy()
      this.DonationGatewayActive = false
    }
  }
}
